module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Stranded_eBook-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "EB",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Stranded_eBook5#Foreword"
    }
  }, [_c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v("Foreword by Ian Rankin")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Stranded_eBook6#Mittel"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Mittel")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Stranded_eBook7#Driving-a-Hard-Bargain"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Driving a Hard Bargain")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook8#The-Wagon-Mound",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "char-style-override-9"
  }, [_vm._v("Wagon Mound")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook9#Breathtaking-Ignorance",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Breathtaking Ignorance")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook10#White-Nights--Black-Magic",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("White Nights, Black Magic")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook11#The-Writing-on-the-Wall",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("The Writing on the Wall")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook12#Keeping-on-the-Right",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Keeping on the Right Side of the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook13#A-Wife-in-a-Million",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("A Wife in a Million")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook14#Traditional-Christmas",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("A Traditional Christmas")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook15#Girl-Who-Killed-Santa",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("The Girl Who Killed ")]), _c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Santa Claus")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook16#Sneeze-for-Danger",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Sneeze for Danger")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook17#Guilt-Trip",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Guilt Trip")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook18#Homecoming",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Homecoming")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook19#Heartburn",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Heartburn")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook20#Four-Calling-Birds",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Four Calling Birds")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook21#Consolation-Blonde",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("The Consolation Blonde")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook22#Metamorph",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("Metamorphosis")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook23#When-Larry-Met",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("When Larry Met Allie")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara para-style-override-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Stranded_eBook24#The-Road-and-the-Miles",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("The Road and the Miles to Dundee")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e40c3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stranded_eBook4.vue
// module id = 72
// module chunks = 0